import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
const DEFAULT_STEP_MS = 24;
const DEFAULT_MAX_CHARS_PER_STEP = 16;
const REVEAL_FRACTION = 0.2;
interface SmoothStreamOptions {
  stepMs?: number;
  maxCharsPerStep?: number;
}
export const useSmoothStreamingText = (targetText, isStreaming, options) => {
  const $ = _c(10);
  const stepMs = options?.stepMs ?? DEFAULT_STEP_MS;
  const maxCharsPerStep = options?.maxCharsPerStep ?? DEFAULT_MAX_CHARS_PER_STEP;
  let t0;
  if ($[0] !== isStreaming || $[1] !== targetText) {
    t0 = () => isStreaming ? "" : targetText;
    $[0] = isStreaming;
    $[1] = targetText;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [displayedText, setDisplayedText] = useState(t0);
  const targetRef = useRef(targetText);
  const displayedRef = useRef(displayedText);
  const timerRef = useRef(null);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = next => {
      displayedRef.current = next;
      setDisplayedText(next);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const set = t1;
  let t2;
  let t3;
  if ($[4] !== isStreaming || $[5] !== maxCharsPerStep || $[6] !== stepMs || $[7] !== targetText) {
    t2 = () => {
      targetRef.current = targetText;
      if (!isStreaming) {
        if (timerRef.current !== null) {
          window.clearTimeout(timerRef.current);
          timerRef.current = null;
        }
        set(targetText);
        return;
      }
      if (!targetText.startsWith(displayedRef.current)) {
        set("");
      }
      const tick = () => {
        const current = displayedRef.current;
        const target = targetRef.current;
        if (!target.startsWith(current)) {
          set(target);
          timerRef.current = null;
          return;
        }
        if (current.length >= target.length) {
          timerRef.current = null;
          return;
        }
        const remaining = target.length - current.length;
        const step = Math.min(maxCharsPerStep, Math.max(1, Math.ceil(remaining * REVEAL_FRACTION)));
        set(target.slice(0, current.length + step));
        timerRef.current = window.setTimeout(tick, stepMs);
      };
      if (timerRef.current === null) {
        timerRef.current = window.setTimeout(tick, stepMs);
      }
      return () => {
        if (timerRef.current !== null) {
          window.clearTimeout(timerRef.current);
          timerRef.current = null;
        }
      };
    };
    t3 = [isStreaming, targetText, stepMs, maxCharsPerStep];
    $[4] = isStreaming;
    $[5] = maxCharsPerStep;
    $[6] = stepMs;
    $[7] = targetText;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  return displayedText;
};